import React from 'react' 
import Form from '../components/auth/register/Form/Form'

function Register() {
  return (
    <Form />
  )
}

export default Register